import {
  OrderPaymentOverview,
  OrderPaymentStatus,
  OrderPaymentType,
  OrderStatusValue,
} from '@ca/common/types'
import { StatusVariant } from '@ui/elements/Status/types'
import { colors } from '@ui/colors'
import { TypographyProps } from '@ui/typography/types'
import { IconName } from '@ui/elements/Icon'

export const borderRadius = 24
export const height = 200

export const orderStatusToVariant: Record<OrderStatusValue, StatusVariant> = {
  draft: 'warning',
  sent: 'warning',

  submit: 'attention',
  pending: 'attention',

  sale: 'active',
  ship: 'active',
  shipping: 'active',
  ready: 'active',

  pick: 'success',
  picked: 'success',
  done: 'success',

  cancel: 'danger',
  unknown: 'neutral',
}

export const orderPaymentOverviewToVariant: Record<
  OrderPaymentOverview,
  StatusVariant
> = {
  none: 'danger',
  partially: 'warning',
  paid: 'success',
}

export const orderPaymentStatusToVariant: Record<
  OrderPaymentStatus,
  StatusVariant
> = {
  draft: 'neutral',
  pending: 'attention',
  posted: 'success',
  declined: 'danger',
  unknown: 'neutral',
}

export const orderPaymentTypeIcon: Record<OrderPaymentType, IconName> = {
  inbound: 'cash-banknote-move',
  unknown: 'point',
}

export const orderPaymentOverviewText1: Record<
  OrderPaymentOverview,
  TypographyProps
> = {
  none: {
    color: colors.red[600],
    variant: 'MDB',
  },
  partially: {
    color: colors.amber[500],
    variant: 'MDB',
  },
  paid: {
    color: colors.green[600],
    variant: 'MDB',
  },
}

export const orderPaymentOverviewText2: Record<
  OrderPaymentOverview,
  TypographyProps
> = {
  none: {
    color: colors.red50,
    variant: 'MD',
  },
  partially: {
    color: colors.black25,
    variant: 'MD',
  },
  paid: {
    color: colors.green50,
    variant: 'MD',
  },
}

export const colorPaymentOverviewLine: Record<OrderPaymentOverview, string> = {
  none: colors.red[600],
  partially: colors.amber[400],
  paid: colors.green[600],
}
